import { Box, Typography } from "@mui/material"
import DynamicTable from "../dynamicTable";

const tableHeader = ["Updated At", "Edited By", "Message"];
const displayRows = ["agreemnts_logs_changed_date", "agrement_changedBy", "message"];

const ServiceAgrementLogs = ({ logs }) => {
    return (
        <Box>
            <Typography variant="h6" my={2}>All Logs</Typography>
            <DynamicTable
                tableData={logs || []}
                tableHeader={tableHeader}
                displayRows={displayRows}
                showPagination={false}
            />

            {logs?.length === 0 && (
                <Typography variant="h5" fontWeight={600} textAlign={"center"} mt={2}>No logs found</Typography>
            )}
        </Box>
    );
};

export default ServiceAgrementLogs;